import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgCommonModule } from '../ng-common.module';

@Component({
  selector: 'pt-buttons-container',
  templateUrl: './buttons-container.component.html',
  styleUrls: ['./buttons-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgCommonModule],
})
export class ButtonsContainerComponent {
  @Input() alignment: 'start' | 'center' | 'end' | 'space-between' = 'end';
  @Input() direction: 'row' | 'column' = 'row';
  @Input() padding: 'vertical' | 'horizontal' | 'all-round' | 'none' =
    'vertical';

  public get fxAlignment(): string {
    return this.direction === 'row'
      ? `${this.alignment} center`
      : `start stretch`;
  }
}
